import Layout from '@/layout/layout'

export default {
    path: '/OnlinreyService',
    component: Layout,
    redirect: 'noRedirect',
    name: '线上回收业务',
    children: [{
        path: 'advertManagement',
        component: () => import('@/views/OnlinreyService/advertManagement/index'),
        name: '广告管理',
        meta: {
            title: '广告管理',
            noCache: true
        }
    },
    {
        path: 'complaintManage',
        component: () => import('@/views/OnlinreyService/complaintManage/index'),
        name: '投诉管理',
        meta: {
            title: '投诉管理',
            noCache: true
        }
    },
    {
        path: 'resourceAllocation',
        component: () => import('@/views/OnlinreyService/resourceAllocation/index'),
        name: '资源配置',
        meta: {
            title: '资源配置',
            noCache: true
        }
    },
    {
        path: 'addAds',
        component: () => import('@/views/OnlinreyService/addAds/index'),
        name: '新增广告',
        meta: {
            title: '新增广告',
            noCache: true
        }
    },
    {
        path: 'OnlineStoreManagement',
        component: () => import('@/views/OnlinreyService/OnlineStoreManagement/index'),
        name: '线上门店管理',
        meta: {
            title: '线上门店管理',
            noCache: true
        }
    },
    {
        path: 'addStore',
        component: () => import('@/views/OnlinreyService/addStore/index'),
        name: '门店信息编辑',
        meta: {
            title: '门店信息编辑',
            noCache: true
        }
    },
    {
        path: 'recyclingParams',
        component: () => import('@/views/OnlinreyService/recyclingParams/index'),
        name: '回收参数配置',
        meta: {
            title: '回收参数配置',
            noCache: true
        }
    },
    {
        path: 'timeRedPackage',
        component: () => import('@/views/OnlinreyService/timeRedPackage/index'),
        name: '限时红包设置',
        meta: { title: '限时红包设置', noCache: true }
    },
    {
        path: 'ApplicationBargain',
        component: () => import('@/views/OnlinreyService/ApplicationBargain/index'),
        name: '议价申请',
        meta: {
            title: '议价申请',
            noCache: true
        }
    },
    {
        path: 'SharingPointsManagement',
        component: () => import('@/views/OnlinreyService/SharingPointsManagement/index'),
        name: '分享积分管理',
        meta: {
            title: '分享积分管理',
            noCache: true
        }
    },
    {
        path: 'giftManage',
        component: () => import('@/views/OnlinreyService/giftManage/index'),
        name: '赠品管理',
        meta: {
            title: '赠品管理',
            noCache: true
        }
    },
    {
        path: 'giftBagManage',
        component: () => import('@/views/OnlinreyService/giftBagManage/index'),
        name: '礼包设置',
        meta: {
            title: '礼包设置',
            noCache: true
        }
    },
    {
        path: 'addGiftBag',
        component: () => import('@/views/OnlinreyService/giftBagManage/addGiftBag/index'),
        name: '礼包设置',
        meta: {
            title: '礼包设置',
            noCache: true
        }
    },








































    {
        path: 'problem',
        component: () => import('@/views/OnlinreyService/problem/index'),
        name: '问答配置',
        meta: {
            title: '问答配置',
            noCache: true
        }
    },
    {
        path: 'userList',
        component: () => import('@/views/OnlinreyService/userList/index'),
        name: '用户列表',
        meta: { title: '问答配置', noCache: true }
    },
    {
        path: 'onlineOrder',
        component: () => import('@/views/OnlinreyService/onlineOrder/index'),
        name: '线上订单',
        meta: { title: '线上订单', noCache: true }
    },
    {
        path: 'OrderDetails',
        component: () => import('@/views/OnlinreyService/OrderDetails/index'),
        name: '订单详情',
        meta: { title: '订单详情', noCache: true }
    },
    {
        path: 'categoryList',
        component: () => import('@/views/OnlinreyService/categoryList/index'),
        name: '分类列表',
        meta: {
            title: '分类列表',
            noCache: true
        }
    },
    ]
}